import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import {
  Avatar,
  Button,
  CardActions,
  CardContent,
  CardHeader,
  createStyles,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  TextField,
  Theme,
  Typography,
  withStyles,
  WithStyles
} from '@material-ui/core';
import {
  CalendarToday,
  DirectionsBike,
  EventNote,
  LocalCafe,
  LocalDrink,
  NavigateBefore,
  NavigateNext,
  Restaurant
} from '@material-ui/icons';

import { IRouteStore } from '../RouteStore';

import { IDiaryPageStore } from './DiaryPageStore';

const styles = (theme: Theme) => createStyles({
  slide: {
    color: '#fff',
  }
});

declare type stylesKeys = 'slide';

interface IDiaryViewProps extends InjectedIntlProps {
  diaryPage: IDiaryPageStore;
  routes: IRouteStore;
}

@observer
class DiaryPageView extends React.Component<IDiaryViewProps & WithStyles<stylesKeys>, {}> {

  public componentWillMount() {
    const { diaryPage } = this.props;
    diaryPage.refresh();
  }

  public render() {
    const { diaryPage, intl: { formatMessage } } = this.props;

    return <React.Fragment>
        <CardHeader
          title={<Grid container={true} spacing={8}>
            <Grid item={true} xs={2}>
            <IconButton onClick={this.handleBefore}>
              <NavigateBefore/>
            </IconButton>
            </Grid>
            <Grid item={true} xs={8}>
              <TextField
                id="date"
                type="date"
                value={diaryPage.dateStr}
                onChange={this.onDateChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarToday/>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item={true} xs={2}>
              <IconButton onClick={this.handleNext}>
                <NavigateNext/>
              </IconButton>
            </Grid>
            </Grid>
          }
        />
        {diaryPage.empty &&
          <React.Fragment>
            <CardContent>
                <Typography key="empty-body" variant="body2">
                  {formatMessage({id: 'diary.meal.list.empty.title'})}
                </Typography>
                <Typography key="empty-subtitle" variant="subtitle2" color="textSecondary">
                  {formatMessage({id: 'diary.meal.list.empty.hint'})}
                </Typography>
            </CardContent>
            <CardActions style={{alignContent: 'center'}}>
              <Button variant="fab" color="secondary" aria-label="add" onClick={this.handleAddMeasurement} style={{margin: 'auto'}}>
                {this.getItemIcon('measurement')}
              </Button>
              <Button variant="fab" color="secondary" aria-label="add" onClick={this.handleAddDrink} style={{margin: 'auto'}}>
                {this.getItemIcon('drink')}
              </Button>
              <Button variant="fab" color="secondary" aria-label="add" onClick={this.handleAddMeal} style={{margin: 'auto'}}>
                {this.getItemIcon('meal')}
              </Button>
              <Button variant="fab" color="secondary" aria-label="add" onClick={this.handleAddWather} style={{margin: 'auto'}}>
                {this.getItemIcon('water')}
              </Button>
              <Button variant="fab" color="secondary" aria-label="add" onClick={this.handleAddActivity} style={{margin: 'auto'}}>
                {this.getItemIcon('training')}
              </Button>
            </CardActions>
          </React.Fragment>
        }
        {!diaryPage.empty &&
          <React.Fragment>
            <CardActions>
              <IconButton color="secondary" onClick={this.handleAddMeasurement}>
                <EventNote/>
              </IconButton>
              <IconButton color="secondary" onClick={this.handleAddDrink}>
                <LocalCafe/>
              </IconButton>
              <IconButton color="secondary" onClick={this.handleAddMeal}>
                <Restaurant/>
              </IconButton>
              <IconButton color="secondary" onClick={this.handleAddWather}>
                <LocalDrink/>
              </IconButton>
              <IconButton color="secondary" onClick={this.handleAddActivity}>
                <DirectionsBike/>
              </IconButton>
            </CardActions>
            <CardContent>
              {diaryPage.loading
              ? <div/>
              : <List>
                {diaryPage.items.map((item: any) =>
                  <ListItem key={item.id} button={true} onClick={this.handleItemClick}>
                    {item.hasThumbnail
                      ? <ListItemAvatar>
                          <Avatar src={item.thumbnailUrl}/>
                        </ListItemAvatar>
                      : <ListItemIcon>
                          {this.getItemIcon(item.type)}
                        </ListItemIcon>
                    }
                    <ListItemText secondary={item.description} primary={item.date.slice(11, 16)}/>

                  </ListItem>
                )}
                </List>
              }
            </CardContent>
          </React.Fragment>
        }
      </React.Fragment>;
  }

  private getItemIcon = (itemType: string) => {
    window.console.log(`type: ${itemType}`);
    switch(itemType) {
      case 'drink':
        return <LocalCafe/>;
      case 'water':
        return <LocalDrink/>;
      case 'training':
        return <DirectionsBike/>;
      case 'measurement':
        return <EventNote/>;
      case 'meal':
      default:
        return <Restaurant/>;
    }
  }

  private handleAddActivity = () => {
    const { routes } = this.props;
    routes.navigate('diary-activity-add');
  }

  private handleAddMeal = () => {
    const { routes } = this.props;
    routes.navigate('diary-meal-add');
  }

  private handleAddMeasurement = () => {
    const { routes } = this.props;
    routes.navigate('diary-measurement-add');
  }

  private handleAddWather = () => {
    const { routes } = this.props;
    routes.navigate('diary-wather-add');
  }

  private handleAddDrink = () => {
    const { routes } = this.props;
    routes.navigate('diary-drink-add');
  }

  private handleItemClick = () => {
    window.console.log('item click');
  }

  private handleNext = () => {
    const { diaryPage } = this.props;
    diaryPage.next();
  }

  private handleBefore = () => {
    const { diaryPage } = this.props;
    diaryPage.previous();
  }

  private onDateChange = (event: any) => {
    const { diaryPage } = this.props;
    if (event && event.target && event.target.value) {
      diaryPage.setDate(new Date(event.target.value));
    }
  }

}

export default withStyles<stylesKeys>(styles)(injectIntl<InjectedIntlProps>(inject('diaryPage', 'routes')(DiaryPageView)));



// WEBPACK FOOTER //
// ./src/diary/DiaryPageView.tsx